import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as o}from"../../icon-registry.js";const p=o("jcb",t`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            static
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_4874_1084"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24">
                <circle
                    cx="12"
                    cy="12"
                    r="12"
                    fill="#FCFCFC" />
            </mask>
            <g mask="url(#mask0_4874_1084)">
                <path
                    d="M24 19.1619C24 21.8286 22.3276 24 20.2738 24H0V4.83809C0 2.17143 1.67237 0 3.72616 0H24V19.1619Z"
                    fill="white" />
                <path
                    d="M16.5 13.5003H17.7836C17.8203 13.5003 17.9059 13.4876 17.9425 13.4876C18.187 13.4368 18.3949 13.2082 18.3949 12.8908C18.3949 12.586 18.187 12.3574 17.9425 12.2939C17.9059 12.2812 17.8325 12.2813 17.7836 12.2813H16.5V13.5003Z"
                    fill="url(#paint0_linear_4874_1084)" />
                <path
                    d="M17.6356 5.08203C16.4131 5.08203 15.4107 6.1106 15.4107 7.39314V9.79314H18.5525C18.6258 9.79314 18.7114 9.79314 18.7725 9.80584C19.4816 9.84394 20.0072 10.2249 20.0072 10.8852C20.0072 11.4058 19.6527 11.8503 18.9926 11.9392V11.9646C19.7138 12.0154 20.264 12.4344 20.264 13.082C20.264 13.7804 19.6527 14.2376 18.8459 14.2376H15.3984V18.936H18.6625C19.885 18.936 20.8874 17.9074 20.8874 16.6249V5.08203H17.6356Z"
                    fill="url(#paint1_linear_4874_1084)" />
                <path
                    d="M18.2359 11.0392C18.2359 10.7344 18.0281 10.5313 17.7836 10.4932C17.7592 10.4932 17.698 10.4805 17.6614 10.4805H16.5V11.5979H17.6614C17.698 11.5979 17.7714 11.5979 17.7836 11.5852C18.0281 11.5471 18.2359 11.344 18.2359 11.0392Z"
                    fill="url(#paint2_linear_4874_1084)" />
                <path
                    d="M5.33873 5.07812C4.11623 5.07812 3.11379 6.1067 3.11379 7.38924V13.0908C3.73726 13.4083 4.38518 13.6115 5.0331 13.6115C5.80327 13.6115 6.21892 13.1289 6.21892 12.4686V9.77654H8.12601V12.4559C8.12601 13.4972 7.50254 14.348 5.38763 14.348C4.10401 14.348 3.10156 14.0559 3.10156 14.0559V18.9194H6.36562C7.58812 18.9194 8.59056 17.8908 8.59056 16.6083V5.07812H5.33873Z"
                    fill="url(#paint3_linear_4874_1084)" />
                <path
                    d="M11.4867 5.07812C10.2642 5.07812 9.26172 6.1067 9.26172 7.38924V10.4115C9.82407 9.91622 10.8021 9.59876 12.3791 9.67495C13.2226 9.71305 14.1272 9.95432 14.1272 9.95432V10.9321C13.6749 10.6908 13.137 10.475 12.4402 10.4242C11.2422 10.3353 10.5209 10.9448 10.5209 12.0115C10.5209 13.0908 11.2422 13.7003 12.4402 13.5988C13.137 13.548 13.6749 13.3194 14.1272 13.0908V14.0686C14.1272 14.0686 13.2348 14.3099 12.3791 14.348C10.8021 14.4242 9.82407 14.1067 9.26172 13.6115V18.9448H12.5258C13.7483 18.9448 14.7507 17.9162 14.7507 16.6337V5.07812H11.4867Z"
                    fill="url(#paint4_linear_4874_1084)" />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_4874_1084"
                    x1="15.4099"
                    y1="12.8923"
                    x2="20.9035"
                    y2="12.8923"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#007940" />
                    <stop
                        offset="0.2285"
                        stop-color="#00873F" />
                    <stop
                        offset="0.7433"
                        stop-color="#40A737" />
                    <stop
                        offset="1"
                        stop-color="#5CB531" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_4874_1084"
                    x1="15.4085"
                    y1="12.0035"
                    x2="20.9024"
                    y2="12.0035"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#007940" />
                    <stop
                        offset="0.2285"
                        stop-color="#00873F" />
                    <stop
                        offset="0.7433"
                        stop-color="#40A737" />
                    <stop
                        offset="1"
                        stop-color="#5CB531" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_4874_1084"
                    x1="15.4098"
                    y1="11.0376"
                    x2="20.9036"
                    y2="11.0376"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#007940" />
                    <stop
                        offset="0.2285"
                        stop-color="#00873F" />
                    <stop
                        offset="0.7433"
                        stop-color="#40A737" />
                    <stop
                        offset="1"
                        stop-color="#5CB531" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_4874_1084"
                    x1="3.1112"
                    y1="11.9996"
                    x2="8.68981"
                    y2="11.9996"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1F286F" />
                    <stop
                        offset="0.4751"
                        stop-color="#004E94" />
                    <stop
                        offset="0.8261"
                        stop-color="#0066B1" />
                    <stop
                        offset="1"
                        stop-color="#006FBC" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_4874_1084"
                    x1="9.23011"
                    y1="11.9996"
                    x2="14.6482"
                    y2="11.9996"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#6C2C2F" />
                    <stop
                        offset="0.1735"
                        stop-color="#882730" />
                    <stop
                        offset="0.5731"
                        stop-color="#BE1833" />
                    <stop
                        offset="0.8585"
                        stop-color="#DC0436" />
                    <stop
                        offset="1"
                        stop-color="#E60039" />
                </linearGradient>
            </defs>
        </svg>
    `);export{p as JCB};
